
(function(template){
  define('vue!optionalClassProgram/components/userComponents/tempUserComponent',[
    "Vue",
    "helpers",
    "vuex",
    'vue!../classComponents/mandatoryComponents/mandatoryClassComponent',
    'vue!../classComponents/optionalComponents/optionalClassComponent',
    'vue!../eventDetailComponent',

  ], function (
    Vue,
    helpers,
    vuex,
    mandatoryClassComponent,
    optionalClassComponent,
    eventDetailComponent
  ) {
    return {
      template: template,
      name: "",
      data: function () {
        return {
          error: '',
          isValid: true
        }
      },
      computed: _.extend(
        vuex.mapState(['users', 'usersWithIds', 'currentlyBookingClassProgram']), {
          isValidAgeForProgram: function () {
             this.isValid = this.verifyAge(this.currentlyBookingClassProgram, this.tempCustomerId)
            !this.isValid  ? this.error = this.programErrorMessage(this.currentlyBookingClassProgram, this.tempCustomerId) : ''
            return  this.isValid
          }
        }),
        watch:{
           isValid:{handler:function(val){
          
           this.$store.commit('addNonQualifiedUser',{userId:this.tempCustomerId,isValid:val,itemOrClassId:this.currentlyBookingClassProgram.SpaItemId})
            },deep:true}
        },
      components: {
        'mandatoryClassComponent': mandatoryClassComponent,
        'optionalClassComponent': optionalClassComponent,
        'eventDetailComponent':eventDetailComponent
      },
    }
  })
})('<div class="temp-user-component"> <!-- <p class="inner-service-error"><strong v-if="!isValidAgeForProgram">{{error}}</strong></p> --> <eventDetailComponent v-bind:customerID="tempCustomerId"></eventDetailComponent> <mandatoryClassComponent v-bind:customerID="tempCustomerId"></mandatoryClassComponent> <optionalClassComponent v-bind:customerID="tempCustomerId"></optionalClassComponent> </div>');
